import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

import zh from './locales/zh.json';

export const SUPPORT_LOCALES = ['zh', 'en', 'ja'];

const isDev = import.meta.env.MODE === 'development';

export type SupportLocale = (typeof SUPPORT_LOCALES)[number];
type MessageSchema = typeof zh;

if (isDev) {
  Promise.all([import('./locales/en.json'), import('./locales/ja.json')]).then(
    ([en, ja]) => {
      // ✅ 為 TypeScript 提供型別檢查，不被使用就不會打包
      console.log('i18n: key and value checked in development mode');
      const allMessages: Record<'zh' | 'en' | 'ja', MessageSchema> = {
        zh,
        en: en.default,
        ja: ja.default,
      };
      void allMessages;
    },
  );
}

const i18n = createI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: {
    zh,
    en: {},
    ja: {},
  },
  legacy: false,
});

export function getLocale(): string {
  return i18n.global.locale.value;
}

export function setI18nLanguage(locale: 'zh' | 'en' | 'ja'): void {
  i18n.global.locale.value = locale;
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  document.querySelector('html')!.setAttribute('lang', locale);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getResourceMessages = (r: any) => r.default || r;

export async function loadLocaleMessages(locale: 'zh' | 'en' | 'ja') {
  // load locale messages
  const messages = await import(`./locales/${locale}.json`).then(
    getResourceMessages,
  );

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages);
  setI18nLanguage(locale);

  return nextTick();
}

export default i18n;
